import { render, staticRenderFns } from "./ShipReviewOverallHitsMisses.vue?vue&type=template&id=283ac6c4&"
import script from "./ShipReviewOverallHitsMisses.vue?vue&type=script&lang=js&"
export * from "./ShipReviewOverallHitsMisses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports